import Collapse from './Collapse';
import CollapseItem from './CollapseItem';

Collapse.Item = CollapseItem;

export type { CollapseProps, CollapseCssVars } from './Collapse';
export type { CollapseItemProps } from './CollapseItem';

export default Collapse;
